import { money, date } from "./purchase-order-presentation";
import type { PurchaseOrdersViewState } from "./purchase-order-view-state";

type Props = Pick<PurchaseOrdersViewState, "management">;

export function PurchaseOrdersManagement({ management }: Props) {
  return (<>
    {management ? (
      <section
        className="purchase-order-management"
        aria-label="Sözleşmeli satın alma görünümü"
      >
        <header>
          <div>
            <span className="section-kicker">YÖNETİM GÖRÜNÜMÜ</span>
            <h2>Sözleşmeli satın alma kontrolü</h2>
          </div>
          <p>
            Otomatik ilerleyen siparişler, limitler ve istisnalar tek yerde.
          </p>
        </header>
        <div className="purchase-order-management-metrics">
          <article>
            <small>Otomatik sipariş</small>
            <strong>{management.metrics.automaticOrders}</strong>
            <span>Sözleşme yetkisiyle</span>
          </article>
          <article>
            <small>Sözleşmeli harcama</small>
            <strong>
              {money(management.metrics.contractedSpend, "TRY")}
            </strong>
            <span>İptaller hariç</span>
          </article>
          <article>
            <small>Yaklaşan bitiş</small>
            <strong>{management.metrics.expiringContracts}</strong>
            <span>30 gün içinde</span>
          </article>
          <article
            className={management.metrics.blockedOperations ? "has-risk" : ""}
          >
            <small>Engellenen işlem</small>
            <strong>{management.metrics.blockedOperations}</strong>
            <span>Uyumsuzluk nedeniyle</span>
          </article>
        </div>
        <div className="purchase-order-shadow-review">
          <div className="purchase-order-shadow-summary">
            <div>
              <span className="section-kicker">GÖLGE MOD</span>
              <strong>İnsan kararı atlanmadan ölçüm</strong>
              <p>
                Motorun tahmini nihai kararla karşılaştırılır; bu kayıtlar
                otomatik sipariş oluşturmaz.
              </p>
            </div>
            <dl>
              <div><dt>Değerlendirme</dt><dd>{management.metrics.shadowAssessments}</dd></div>
              <div><dt>Karar bekleyen</dt><dd>{management.metrics.shadowAwaitingDecision}</dd></div>
              <div><dt>Eşleşen</dt><dd>{management.metrics.shadowMatches}</dd></div>
              <div className={management.metrics.shadowFalsePositives ? "has-risk" : ""}><dt>Yanlış olumlu</dt><dd>{management.metrics.shadowFalsePositives}</dd></div>
            </dl>
          </div>
          {management.shadowReviews.length ? (
            <div className="purchase-order-shadow-list" aria-label="Son gölge değerlendirmeleri">
              {management.shadowReviews.map((review) => (
                <article key={review.id}>
                  <div><strong>{review.supplierName}</strong><span>{review.rfqNo}</span></div>
                  <span>{review.predictedRoute === "WOULD_PREAUTHORIZE" ? "Ön yetkiye uygun tahmini" : "Normal onay tahmini"}</span>
                  <b className={review.classification === "FALSE_POSITIVE" ? "is-risk" : ""}>
                    {review.classification === "FALSE_POSITIVE" ? "Yanlış olumlu" : review.classification === "MATCH" ? "Kararla eşleşti" : "Nihai karar bekleniyor"}
                  </b>
                </article>
              ))}
            </div>
          ) : null}
        </div>
        {management.contracts.length ? (
          <div className="purchase-order-management-contracts">
            {management.contracts.map((contract) => (
              <article key={contract.contractNo}>
                <div>
                  <small>{contract.contractNo}</small>
                  <strong>{contract.supplierName}</strong>
                  <span>{date(contract.validTo)} tarihinde sona erer</span>
                </div>
                <div>
                  <small>Kullanılan / toplam limit</small>
                  <strong>
                    {money(Number(contract.usedLimit), "TRY")} /{" "}
                    {money(Number(contract.totalLimit), "TRY")}
                  </strong>
                  <progress
                    max={Number(contract.totalLimit) || 1}
                    value={Number(contract.usedLimit)}
                  />
                </div>
              </article>
            ))}
          </div>
        ) : null}
      </section>
    ) : null}
  </>);
}
